export const getFormattedPriceAsFloat = (value: number | string) => {
	return parseFloat(String(value).replace(',', '.'));
};
